import { z } from "zod";
import { idSchema, isoDateTimeSchema, paginatedResponseSchema } from "./shared";

export const agentSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  name: z.string().min(1),
  slug: z.string().min(1),
  status: z.enum(["active", "disabled"]),
  createdAt: isoDateTimeSchema,
});

export const agentRunStatusSchema = z.enum([
  "queued",
  "running",
  "waiting_for_human",
  "failed",
  "completed",
  "canceled",
]);

export const agentRunSourceSchema = z.enum(["web", "slack", "cli", "api", "mcp"]);

export const agentRunSchema = z.object({
  id: idSchema,
  issueId: idSchema,
  agentId: idSchema,
  status: agentRunStatusSchema,
  startedByUserId: idSchema,
  source: agentRunSourceSchema,
  goal: z.string().min(1),
  summary: z.string().nullable(),
  error: z.string().nullable(),
  sessionRef: z.string().nullable(),
  branchName: z.string().nullable(),
  pullRequestUrl: z.string().url().nullable(),
  startedAt: isoDateTimeSchema.nullable(),
  lastHeartbeatAt: isoDateTimeSchema.nullable(),
  completedAt: isoDateTimeSchema.nullable(),
});

export const createAgentRunRequestSchema = z.object({
  issueId: idSchema,
  agentId: idSchema,
  source: agentRunSourceSchema,
  goal: z.string().trim().min(1),
});

export const updateAgentRunRequestSchema = z.object({
  status: agentRunStatusSchema.optional(),
  summary: z.string().trim().optional(),
  error: z.string().trim().optional(),
  sessionRef: z.string().trim().optional(),
  branchName: z.string().trim().optional(),
  pullRequestUrl: z.string().url().optional(),
});

export const agentRunFiltersSchema = z.object({
  issueId: idSchema.optional(),
  agentId: idSchema.optional(),
  status: agentRunStatusSchema.optional(),
});

export const agentListResponseSchema = paginatedResponseSchema(agentSchema);
export const agentRunListResponseSchema = paginatedResponseSchema(agentRunSchema);

export const agentDetailResponseSchema = z.object({
  agent: agentSchema,
  metrics: z.object({
    totalRuns: z.number(),
    activeRuns: z.number(),
    waitingRuns: z.number(),
    completedRuns: z.number(),
  }),
  recentRuns: z.array(agentRunSchema),
});
